import React, { useState } from "react";
import { ReactComponent as Sort } from "assets/img/icons/sort.svg";
import { ReactComponent as Arrowup } from "assets/img/icons/arrowup.svg";
import { CSSTransition } from "react-transition-group";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import { useDispatch } from "react-redux";
import ClickAwayListener from "react-click-away-listener";
import * as timelineActions from "reteamStore/actions";
import classNames from "classnames";

export default ({ setSortName }) => {
  const dispatch = useDispatch();
  const [displaySort, setDisplaySort] = useState(false);
  const { allTimelinePost, filters } = useTeamActionContext();
  const [allSortingOptions] = useState([
    {
      id: 1,
      value: "updated_at",
      name: "Recent",
      order: "desc",
    },
    {
      id: 2,
      value: "created_at",
      name: "Newest",
      order: "desc",
    },
    {
      id: 3,
      value: "updated_at",
      name: "Oldest",
      order: "asc",
    },
    {
      id: 4,
      value: "expression_count",
      name: "Engagement",
      order: "desc",
    },
    {
      id: 5,
      value: "buzz_count",
      name: "Reaction",
      order: "desc",
    },
  ]);

  const handleSorting = async ({
    page = 1,
    orderBy,
    order = "desc",
    orderName,
  }) => {
    try {
      setDisplaySort(false);
      await Promise.all([
        dispatch(timelineActions.clearAll()),
        allTimelinePost(
          page,
          { orderName: orderName, order_by: orderBy, order: order },
          filters
        ),
      ]);
      setSortName(orderName);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="sortRoot" onClick={() => setDisplaySort(!displaySort)}>
      <div
        className={classNames({
          sortSvg: !displaySort ? true : false,
          sortsvgActive: displaySort ? true : false,
        })}
      >
        <Sort className="svg" />
      </div>
      <CSSTransition
        in={displaySort}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <ClickAwayListener onClickAway={() => setDisplaySort(false)}>
          <div
            className="sortContent"
            style={{
              boxShadow:
                "rgb(204 204 204) 0px 2px 1px -1px, rgb(204 204 204) 0px 1px 1px 0px, rgb(204 204 204) 0px 1px 3px 0px",
            }}
          >
            <Arrowup className="arrowUp" />
            {allSortingOptions.map((option, index) => (
              <span
                key={index}
                onClick={() =>
                  handleSorting({
                    orderBy: option.value,
                    orderName: option.name,
                    order: option.order,
                  })
                }
              >
                {option.name}
              </span>
            ))}
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
};
